(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($rootScope, $q, $timeout, $http, ProductService, CategoryService, ProviderService, AuthenticationService, HelperService, NotifyService, PATHS) {
        const vm = this;

        let skip = 0;
        let perPage = 6;
        let forcePaginationReset = false;
        const INVALID_SKU_PATTERN = /(compra\s*externa|compra\s*extena|sob\s*pedido|fornecedor\s*externo)/i;
        const KIT_ADESIVOS_NAME = 'KIT ADESIVOS';
        const KIT_ADESIVOS_REQUIRED_PROVIDER = 'EBS COMUNICAÇÃO VISUAL';
        const KIT_SISTEMA_NAME = 'KIT SISTEMA';
        // O KIT SISTEMA só tem as caixas de automação da LOSEC (SYS-AUT-*): a mensalidade (SYS-MENS) deixou de existir.
        const KIT_SISTEMA_REQUIRED_PROVIDERS = ['LOSEC'];
        const DEFAULT_STARTER_KITS = {
            kits: [
                {
                    name: 'Kit Máquinas',
                    description: 'Itens iniciais para operação das máquinas.',
                    items: [
                        { model: '10kg', sku: '12.055.06' },
                        { model: '10kg', sku: 'DOS0009' },
                        { model: '10kg', sku: 'LAV/SEC1' }
                    ]
                },
                {
                   name: 'Kit Móveis',
                    description: 'Itens iniciais de mobiliário e apoio.',
                    items: [
                        { model: '10kg', sku: '12.055.06' },
                        { model: '10kg', sku: 'DOS0009' },
                        { model: '10kg', sku: 'LAV/SEC1' }
                    ]
                },
                {
                    name: 'Kit Adesivos',
                    description: 'Itens iniciais de comunicação visual.',
                    items: [
                        { model: '10kg', sku: '12.055.06' },
                        { model: '10kg', sku: 'DOS0009' },
                        { model: '10kg', sku: 'LAV/SEC1' }
                    ]
                }
            ]
        };

        vm.standard_templates = ['8kg', '10kg', '11kg', '13kg', '15kg'];
        vm.starterKits = { kits: [] };
        vm.isLoadingAddKit = false;
        vm.units = [];
        vm.selectedUnitKit = null;
        vm.pendingKitSkus = [];
        vm.pendingKitSkuQtyMap = {};
        vm.pendingKit = null;

        vm.onSelectSearchFilter = () => {
            forcePaginationReset = true;

            vm.getPaginatedProducts({
                page: vm.currentPage
            });
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.getPaginatedProducts({
                    page: vm.currentPage
                });
            }
        }

        vm.availableModels = (kit) => {
            if (!kit || !kit.items || !kit.items.length) {
                return [];
            }

            const models = kit.items
                .map(item => normalizeText(item.model || item.modelo || item.template || item.Model || item.Modelo))
                .filter(Boolean)
                .filter((model, index, list) => list.indexOf(model) === index);

            return models.sort((a, b) => {
                const indexA = vm.standard_templates.indexOf(a);
                const indexB = vm.standard_templates.indexOf(b);
                const hasA = indexA >= 0;
                const hasB = indexB >= 0;

                if (hasA && hasB) return indexA - indexB;
                if (hasA) return -1;
                if (hasB) return 1;

                return a.localeCompare(b);
            });
        }

        vm.getFilteredItems = (kit) => {
            if (!kit || !kit.items || !kit.items.length) {
                return [];
            }

            if (!kit.selectedModel) {
                return [];
            }

            const selectedModel = normalizeText(kit.selectedModel);

            return kit.items.filter(item => {
                const itemModel = normalizeText(item.model || item.modelo || item.template || item.Model || item.Modelo);

                if (itemModel !== selectedModel) {
                    return false;
                }

                if (!item.choiceGroup) {
                    return true;
                }

                const selectedChoice = kit.selectedChoices && kit.selectedChoices[item.choiceGroup];

                return selectedChoice && normalizeSkuCode(selectedChoice) === normalizeSkuCode(item.sku);
            });
        }

        vm.onKitModelChange = (kit) => {
            if (!kit) {
                return;
            }

            kit.selectedChoices = {};
            kit.choiceGroups = buildChoiceGroups(kit);
            kit.filteredItems = vm.getFilteredItems(kit);
        }

        vm.onKitChoiceChange = (kit) => {
            if (kit) {
                kit.filteredItems = vm.getFilteredItems(kit);
            }
        }

        vm.hasUnselectedChoices = (kit) => {
            if (!kit || !kit.choiceGroups || !kit.choiceGroups.length) {
                return false;
            }

            return kit.choiceGroups.some(group => !kit.selectedChoices || !kit.selectedChoices[group.key]);
        }

        vm.addKit = (kit) => {
            if (!kit || !kit.selectedModel || vm.isLoadingAddKit === kit) {
                return;
            }

            if (vm.hasUnselectedChoices(kit)) {
                NotifyService.warning('Selecione uma opção para completar o kit.');
                return;
            }

            vm.isLoadingAddKit = kit;
            kit.filteredItems = vm.getFilteredItems(kit);

            const skuQtyMap = extractEligibleSkuQtyMap(kit.filteredItems);
            const eligibleSkus = Object.keys(skuQtyMap);
            if (!eligibleSkus.length) {
                NotifyService.warning('Nenhum SKU válido foi encontrado para esse modelo.');
                vm.isLoadingAddKit = null;
                return;
            }

            const units = (AuthenticationService.getUnits() || []).filter(unit => unit && unit.HeadUnitId != null);
            vm.units = units;

            if (units.length > 1) {
                vm.pendingKit = kit;
                vm.pendingKitSkus = eligibleSkus;
                vm.pendingKitSkuQtyMap = skuQtyMap;
                vm.selectedUnitKit = null;
                vm.isLoadingAddKit = null;

                HelperService.showModal('#select-unit-kit');
                return;
            }

            if (units.length === 1) {
                vm.confirmAddKitToUnit(units[0], eligibleSkus, kit, skuQtyMap);
                return;
            }

            const selectedUnit = AuthenticationService.getSelectedUnit();

            if (selectedUnit && selectedUnit.Id) {
                vm.confirmAddKitToUnit(selectedUnit, eligibleSkus, kit, skuQtyMap);
                return;
            }

            vm.isLoadingAddKit = null;
            NotifyService.warning('Nenhuma unidade elegível foi encontrada para adicionar o kit.');
        }

        vm.confirmAddKitToUnit = (selectedUnitArg, skusArg, kitArg, skuQtyMapArg) => {
            const selectedUnit = selectedUnitArg || vm.selectedUnitKit || AuthenticationService.getSelectedUnit();
            const skus = normalizeSkus(skusArg || vm.pendingKitSkus);
            const skuQtyMap = skuQtyMapArg || vm.pendingKitSkuQtyMap || {};
            const currentKit = kitArg || vm.pendingKit;

            if (!selectedUnit || !selectedUnit.Id) {
                NotifyService.warning('Selecione uma unidade para continuar.');
                return;
            }

            if (!skus.length) {
                NotifyService.warning('Nenhum item válido foi encontrado para adicionar.');
                vm.onCloseKitModal();
                vm.isLoadingAddKit = false;
                return;
            }

            vm.isLoadingAddKit = currentKit || true;

            ProductService
                .getProductsBySkus(skus)
                .then(result => {
                    const resolvedProducts = Array.isArray(result) ? result : (result && result.products) || [];
                    const unresolvedSkus = Array.isArray(result && result.unresolvedSkus) ? result.unresolvedSkus : [];
                    const requiredProvider = getRequiredProviderForKit(currentKit);
                    const providerFilteredProducts = requiredProvider
                        ? resolvedProducts.filter(product => hasRequiredProvider(product, requiredProvider))
                        : resolvedProducts;
                    const providerRejectedSkus = requiredProvider
                        ? resolvedProducts
                            .filter(product => !hasRequiredProvider(product, requiredProvider))
                            .map(product => normalizeSkuCode(product.Code || product.code || product.SKU || product.sku))
                            .filter(Boolean)
                        : [];
                    const finalUnresolvedSkus = Array.from(new Set([].concat(unresolvedSkus, providerRejectedSkus)));

                    if (!providerFilteredProducts.length) {
                        NotifyService.warning('Nenhum produto com fornecedor válido foi encontrado para os SKUs informados.');
                        return;
                    }

                    const productsToAdd = providerFilteredProducts.map(product => {
                        const productSku = normalizeSkuCode(product.Code || product.code || product.SKU || product.sku);
                        product.Amount = Number(skuQtyMap[productSku]) || 1;
                        product.UnitId = selectedUnit.Id;
                        product.Unit = selectedUnit;

                        return product;
                    });

                    logKitPriceAudit(currentKit, productsToAdd, finalUnresolvedSkus);

                    ProductService.addProducts(productsToAdd);
                    getCart();
                    if (finalUnresolvedSkus.length) {
                        NotifyService.warning(finalUnresolvedSkus.length + ' item(ns) do kit não foram adicionados por estarem indisponíveis: ' + finalUnresolvedSkus.join(', ') + '.');
                    }
                    NotifyService.success('Kit adicionado ao carrinho.');
                }, error => errorCallback(error))
                .finally(() => {
                    vm.isLoadingAddKit = false;
                    vm.onCloseKitModal();
                });
        }

        vm.onCloseKitModal = () => {
            vm.selectedUnitKit = null;
            vm.pendingKitSkus = [];
            vm.pendingKitSkuQtyMap = {};
            vm.pendingKit = null;
            vm.isLoadingAddKit = false;
            HelperService.hideModal('#select-unit-kit');
        }

        vm.getPaginatedProducts = pageData => {
            vm.isLoading = true;
            vm.products = [];

            if (forcePaginationReset) {
                vm.currentPage = 1;
                skip = 0;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            skip = (vm.currentPage - 1) * perPage;

            getProducts();
        }

        init();

        function getProducts() {
            HelperService.startLoading('.products-holder');

            let params = prepareParameters();

            return ProductService
                .getAllByParameters(params)
                .then(success => {
                    vm.products = success.Products.reduce((acc, cur) => {
                        cur.Amount = 1;
                        acc.push(cur);

                        return acc;
                    }, []);
                    vm.totalOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                    HelperService.stopLoading('.products-holder');
                }, error => errorCallback(error))
        }

        function getCart() {
            vm.cartProducts = ProductService.getProducts();
        }

        function getCategories() {
            return CategoryService
                .getAll()
                .then(
                    success => vm.categories = success,
                    error => HelperService.errorCallback(error)
                )
        }

        function getProviders() {
            return ProviderService
                .getAll()
                .then(
                    success => vm.providers = success,
                    error => HelperService.errorCallback(error)
                )
        }

        function prepareParameters() {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Featured',
                OrderDescending: true,
                IsForStore: true
            }

            if (vm.selectedCategory)
                params.CategoryId = vm.selectedCategory.Id;

            if (vm.selectedProvider)
                params.ProviderId = vm.selectedProvider.Id;

            if (vm.searchText) {
                params.SearchField = "TitleCode";
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function errorCallback(error) {
            vm.isLoading = false;

            HelperService.errorCallback(error);
            HelperService.stopLoading('.cart-holder');
            HelperService.stopLoading('.products-holder');
        }

        function init() {
            $rootScope.addDivisor = true;

            vm.products = [];
            vm.cartProducts = [];
            vm.cartTotal = 0;
            vm.currentPage = 1;

            vm.isLoading = true;

            HelperService.startLoading('.search-holder');

            $q.all([getCategories(), getProviders()])
                .then(() => {
                    HelperService.stopLoading('.search-holder');

                    vm.getPaginatedProducts({
                        page: vm.currentPage
                    });

                    loadStarterKits();
                    getCart();
                })
        }

        function loadStarterKits() {
            // O IIS manda cachear os estáticos por 1 dia (max-age=86400), e o cache: false só vale para o cache do $http:
            // sem o parâmetro, o navegador seguia mostrando o kit antigo depois do deploy.
            return $http
                .get(`${PATHS.PHYSICAL}/components/products/starter-kits.json`, { cache: false, params: { v: Date.now() } })
                .then(success => {
                    const starterKits = success && success.data ? success.data : DEFAULT_STARTER_KITS;
                    applyStarterKits(starterKits);
                }, () => {
                    applyStarterKits(DEFAULT_STARTER_KITS);
                });
        }

        function applyStarterKits(starterKits) {
            const kits = (starterKits.kits || []).map(kit => {
                kit.items = (kit.items || []).filter(item => {
                    const code = normalizeSkuCode(item && (item.sku || item.SKU || item.code || item.Code || item.codigo || item.Codigo));
                    return Boolean(code) && !INVALID_SKU_PATTERN.test(code);
                });
                kit.selectedModel = null;
                kit.selectedChoices = {};
                kit.choiceGroups = [];
                kit.filteredItems = [];

                return kit;
            });

            vm.starterKits = {
                kits
            };
        }

        function extractEligibleSkuQtyMap(items) {
            if (!items || !items.length) {
                return {};
            }

            return items.reduce((acc, item) => {
                const code = normalizeSkuCode(item.sku || item.SKU || item.code || item.Code || item.codigo || item.Codigo);
                const qty = Number(item.qty);
                const amount = Number.isFinite(qty) ? qty : 1;

                if (!code || INVALID_SKU_PATTERN.test(code) || amount <= 0) {
                    return acc;
                }

                acc[code] = (acc[code] || 0) + amount;

                return acc;
            }, {});
        }

        function buildChoiceGroups(kit) {
            if (!kit || !kit.selectedModel || !kit.items) {
                return [];
            }

            const selectedModel = normalizeText(kit.selectedModel);
            const groups = {};

            kit.items.forEach(item => {
                const itemModel = normalizeText(item.model || item.modelo || item.template || item.Model || item.Modelo);

                if (itemModel !== selectedModel || !item.choiceGroup) {
                    return;
                }

                if (!groups[item.choiceGroup]) {
                    groups[item.choiceGroup] = {
                        key: item.choiceGroup,
                        label: item.choiceLabel || 'Escolha uma opção',
                        options: []
                    };
                }

                groups[item.choiceGroup].options.push({
                    sku: item.sku,
                    label: item.item
                });
            });

            return Object.keys(groups).map(key => groups[key]);
        }

        function normalizeSkus(skus) {
            if (!skus || !skus.length) {
                return [];
            }

            return skus
                .map(normalizeSkuCode)
                .filter(Boolean)
                .filter((code, index, list) => list.indexOf(code) === index);
        }

        function normalizeSkuCode(value) {
            let code = normalizeText(value);

            if (!code) {
                return '';
            }

            // Canonicalize LavPop prefixed SKUs to API catalog format.
            if (/^LP(?=\d|QUI)/.test(code) && code.indexOf('LP-') !== 0) {
                code = code.replace(/^LP(?=\d|QUI)/, 'LP-');
            }

            // Keep catalog SKU as configured in starter-kits (e.g. LP-16.155.08).
            code = code.replace(/-+$/, '');

            return code;
        }

        function normalizeText(value) {
            if (value === null || value === undefined) {
                return '';
            }

            return value.toString().trim().toUpperCase();
        }

        function normalizeCompareText(value) {
            const normalized = normalizeText(value);

            if (!normalized || !normalized.normalize) {
                return normalized;
            }

            return normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        function getRequiredProviderForKit(kit) {
            if (!shouldEnforceKitProviderValidation()) {
                return '';
            }

            const kitName = normalizeCompareText(kit && kit.name);

            if (kitName === normalizeCompareText(KIT_ADESIVOS_NAME)) {
                return KIT_ADESIVOS_REQUIRED_PROVIDER;
            }

            if (kitName === normalizeCompareText(KIT_SISTEMA_NAME)) {
                return KIT_SISTEMA_REQUIRED_PROVIDERS;
            }

            return '';
        }

        function hasRequiredProvider(product, requiredProviderName) {
            if (!requiredProviderName) {
                return true;
            }

            const rawProvider = product && product.Provider;
            const providerTitle = typeof rawProvider === 'string'
                ? rawProvider
                : (rawProvider && (rawProvider.Title || rawProvider.Name || rawProvider.ProviderName));
            const providerName = normalizeCompareText(providerTitle);
            const requiredNames = (Array.isArray(requiredProviderName) ? requiredProviderName : [requiredProviderName])
                .map(normalizeCompareText)
                .filter(Boolean);

            if (!providerName || !requiredNames.length) {
                return false;
            }

            // Accepts expected provider with common catalog variations
            // e.g. "EBS COMUNICACAO VISUAL LTDA"
            return requiredNames.some(requiredName => providerName === requiredName || providerName.indexOf(requiredName) >= 0);
        }

        function shouldEnforceKitProviderValidation() {
            const host = window && window.location && window.location.hostname
                ? window.location.hostname.toLowerCase()
                : '';

            // Local environment should not block kit tests by provider mismatch.
            return host !== 'central-local.lavpop.com.br';
        }

        function logKitPriceAudit(kit, products, unresolvedSkus) {
            if (!products || !products.length) {
                return;
            }

            const rows = products.map(product => {
                const sku = normalizeSkuCode(product.Code || product.code || product.SKU || product.sku);
                const qty = Number(product.Amount) || 1;
                const selectedValue = getPreferredProductValue(product);
                const unitValue = Number(
                    selectedValue && selectedValue.Value != null
                        ? selectedValue.Value
                        : (product.Value != null ? product.Value : 0)
                ) || 0;
                const subtotal = qty * unitValue;
                const providerName = (product.Provider && (product.Provider.Title || product.Provider.Name)) || '';

                return {
                    kit: (kit && kit.name) || '',
                    model: (kit && kit.selectedModel) || '',
                    sku: sku,
                    title: product.Title || product.Name || '',
                    provider: providerName,
                    qty: qty,
                    unitValue: unitValue,
                    subtotal: subtotal
                };
            });

            const total = rows.reduce((acc, row) => acc + row.subtotal, 0);
            const audit = {
                kit: (kit && kit.name) || '',
                model: (kit && kit.selectedModel) || '',
                generatedAt: new Date().toISOString(),
                rows: rows,
                unresolvedSkus: unresolvedSkus || [],
                total: total
            };

            window.__lastKitPriceAudit = audit;

            if (console && console.groupCollapsed) {
                console.groupCollapsed('[KIT AUDIT] ' + audit.kit + ' | ' + audit.model + ' | total=' + total.toFixed(2));
                if (console.table) {
                    console.table(rows);
                } else {
                    console.log(rows);
                }
                if (audit.unresolvedSkus.length) {
                    console.log('SKUs não adicionados:', audit.unresolvedSkus);
                }
                console.log('Total do kit:', total);
                console.groupEnd();
            }
        }

        function getPreferredProductValue(product) {
            if (!product || !product.ProductValue || !product.ProductValue.length) {
                return null;
            }

            let selectedProductValue = product.ProductValue.find(value => value && value.Active && value.StockAvailable > 0);

            if (!selectedProductValue) {
                selectedProductValue = product.ProductValue.find(value => value && value.StockAvailable > 0);
            }

            return selectedProductValue || product.ProductValue[0] || null;
        }
    }
}());
